import { http } from "../client";
export var refreshTrackDurations = function (_a) {
    var tracksIds = _a.tracksIds;
    return http.api
        .post("tracks/refresh-durations", {
        tracks: tracksIds,
    })
        .then(function (response) { return response.data.data; });
};
